import { selectFiltersQuery } from 'util/selector/querySelector';

import { ResponseRate } from 'model/ResponseRate';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { STORE_NAME } from 'reduxStore/responseRate/initialState';
import { projectApi } from 'container/projectApi';

export const fetchProjectResponseRate = createAsyncThunk<ResponseRate, { projectId: number }>(
  `${STORE_NAME}/fetchResponseRate`,
  async ({ projectId }, { getState }) => {
    const query = selectFiltersQuery(getState());
    return projectApi.getResponseRate(projectId, query);
  }
);
